import { render, staticRenderFns } from "./categoryPro.vue?vue&type=template&id=b5707e0c"
import script from "./categoryPro.vue?vue&type=script&lang=js"
export * from "./categoryPro.vue?vue&type=script&lang=js"
import style0 from "./categoryPro.vue?vue&type=style&index=0&id=b5707e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports